import React, { useState, useEffect } from 'react';

import { Header } from '../Header';
import { Button } from '../Button';
import { ButtonBar } from '../ButtonBar';
import { InstructionSvgWrapper } from './InstructionSvgWrapper';
import { FullHeightContainer } from '../Containers';

import {
    createEnterExitAnimation,
    createFadeInOutAnimation,
} from '../../transitions';
import { createMarkup, pushToDataLayer } from '../../utils';
import { animationDelay } from '../../constants';

interface IProps {
    headerText: string;
    stepDisplayNumber: number;
    svgComponent?: React.FC;
    onAnimationExit(): void;
}

export const ChoiceDisplayInstruction: React.FC<IProps> = ({
    headerText,
    stepDisplayNumber,
    svgComponent,
    onAnimationExit,
}) => {
    const [componentStage, setComponentStage] = useState('enter');

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === 'ArrowRight') {
            setComponentStage('exit');
        }
    };

    const handleButtonClick = () => {
        pushToDataLayer(`${stepDisplayNumber}: ${headerText}`);
        setComponentStage('exit');
    };

    const handleAnimationExit = () => {
        if (componentStage === 'exit') {
            onAnimationExit();
        }
    };

    const firstAnimation = createEnterExitAnimation({ stage: componentStage });
    const secondAnimation = createFadeInOutAnimation({
        stage: componentStage,
        delay: animationDelay.second,
    });
    const thirdAnimation = createFadeInOutAnimation({
        stage: componentStage,
        delay: animationDelay.third,
        onRest: handleAnimationExit,
    });

    const SvgComponent = svgComponent;

    return (
        <>
            <FullHeightContainer>
                <Header
                    dangerouslySetInnerHTML={createMarkup(headerText)}
                    style={firstAnimation}
                />
                {SvgComponent && (
                    <InstructionSvgWrapper style={secondAnimation}>
                        <SvgComponent />
                    </InstructionSvgWrapper>
                )}
            </FullHeightContainer>
            <ButtonBar>
                <Button style={thirdAnimation} onClick={handleButtonClick}>
                    oké
                </Button>
            </ButtonBar>
        </>
    );
};
